import { Dropdown } from 'antd';
import { useToggleVisibility } from '../hooks';
import { MoreOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export type Placement =
  | 'topLeft'
  | 'topCenter'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomCenter'
  | 'bottomRight'
  | 'top'
  | 'bottom';

interface IProps {
  placement?: Placement;
  isVisible?: boolean;
  children: React.ReactNode | React.ReactNode[];
  onShow?(): void;
  onHide?(): void;
  wrapperStyle?: React.CSSProperties;
  menuStyle?: React.CSSProperties;
}

const ActionMenu: React.FC<IProps> = ({
  children,
  placement = 'bottomLeft',
  isVisible: propsIsVisible,
  onHide,
  onShow,
  wrapperStyle,
  menuStyle,
}) => {
  const { isVisible, show, hide } = useToggleVisibility();

  const handleHide = () => {
    if (onHide) onHide();
    else hide();
  };

  const handleShow = () => {
    if (onShow) onShow();
    else show();
  };

  const shouldShow = propsIsVisible !== undefined ? propsIsVisible : isVisible;

  return (
    <Dropdown
      popupRender={() => (
        <ActionMenuContent
          style={menuStyle}
          onClick={(e: any) => {
            e.preventDefault();
            e.stopPropagation();
            handleHide();
          }}
        >
          {children}
        </ActionMenuContent>
      )}
      placement={placement}
      trigger={['click']}
      open={shouldShow}
      onOpenChange={visible => {
        visible ? handleShow() : handleHide();
      }}
      arrow
      overlayStyle={{ minWidth: '120px' }}
    >
      <Icon
        style={wrapperStyle}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          handleShow();
        }}
      >
        <MoreOutlined />
      </Icon>
    </Dropdown>
  );
};

const ActionMenuContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 3px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow:
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);
  padding: ${({ theme }) => theme.spacing.xs};
  border-radius: ${({ theme }) => theme.spacing.xs};
`;

export const ActionMenuItem = styled.span`
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  padding: ${({ theme }) => theme.spacing.xs} 12px;
  border-radius: ${({ theme }) => theme.spacing.xs};
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: rgba(53, 25, 25, 0.04);
  }
`;

const Icon = styled.div`
  cursor: pointer;
  width: ${({ theme }) => theme.spacing.lg};
  margin: 0 0 0 13px;
  padding: 0;
  .anticon {
    color: ${({ theme }) => theme.colors.black};
    svg {
      transform: scale(1.2);
    }
  }
  .anticon:hover {
    color: ${({ theme }) => theme.colors.gray};
  }
`;

export default ActionMenu;
